//
// # Wire Routing Utilities
//
// Shared helper functions for wire routing and cleanup operations.
//

import { Point, model } from "GenAlphaModel";
import type { WireSegment } from "../content/schematic/wire";
import type { SchPin } from "../content/schematic/instance";

// Grid and routing constants
export const SCHEMATIC_GRID_SIZE = 10;
export const SCHEMATIC_BEND_COST = 5;

// Create a unique key for a point (for Set/Map operations)
export function pointKey(p: Point): string {
  return `${p.x},${p.y}`;
}

// Get the world location of a schematic pin's wire connection point.
// For SchPins, the wire connects at (0,0) in local coordinates (the tip of the pin shape),
// which transforms to the xform location in world coordinates.
export function getSchPinWorldLocation(schPin: SchPin): Point {
  // The wire connection point is at (0,0) in local coordinates
  // Transform to world coordinates using the schematic pin's xform
  return model.Xform.transform(schPin.xform, { x: 0, y: 0 });
}
